// extracted by mini-css-extract-plugin
export default {"container":"CreateIndexDialog-module__container--ZOoB7","header":"CreateIndexDialog-module__header--BOTnW","headerSubtext":"CreateIndexDialog-module__headerSubtext--OeUYC"};